import { combineReducers } from 'redux';
import { useDispatch, useSelector } from 'react-redux';
import { startApp } from '../actions/AppActions';
export function useAppDispatch() {
  return useDispatch();
}
export function useAppSelector(selector) {
  return useSelector(selector);
}
export const rootReducer = combineReducers({
  noop: (state = {}, __action) => state
});
export const initialState = rootReducer(undefined, startApp());